<template>
	<v-app id="app">
		<NetworkMessages ref="messages" />
		<Navigation @show-auth="showAuthentication = true" />

		<v-main>
			<v-container class="pt-16" fill-height>
				<h1 class="text-h2 mb-8" v-if="showPageTitle" v-text="pageTitle" />

				<v-row>
					<v-col>
						<router-view id="view" :key="$route.fullPath" />
					</v-col>
				</v-row>
			</v-container>
		</v-main>

		<LoadingAnimation :show="showLoading" />
		<AmplifyAuthentication v-if="showAuthentication" @close="showAuthentication = false" />

		<Footer :contactInfo="contactInfo" />
	</v-app>
</template>

<script>
import routes from '@/router/routes'

import Navigation from './components/base/AppNavigation'
import Footer from './components/base/AppFooter'

import LoadingAnimation from './components/base/AppLoading'

import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import AmplifyAuthentication from './components/dialogs/AmplifyAuthentication'

import bus from '@/eventbus'

export default {
	name: 'App',
	routes,
	components: {
		Navigation,
		Footer,
		LoadingAnimation,
		AmplifyAuthentication,
		// Components imports on demand:
		NetworkMessages: () => import('@/components/admin/NetworkMessages'),
	},

	metaInfo: {
      title: 'PRIMAR',
      titleTemplate: '%s | PRIMAR'
  },

	data: () => ({
		showAuthentication: false,
		showLoading: false,
		contactInfo: {}
	}),

	created() {
		// Listen to the global event bus
		bus
			.$on('loading-show', this.showLoad)
			.$on('loading-close', this.closeLoad)
			.$on('auth-show', this.showAuth)
			.$on('auth-close', this.closeAuth)
			.$on('show-message', this.showMessage)
			.$on('router-go', function (path) {
				this.$router.push(path)
			})

		// Init account storage, checks for existing login session
		this.$store.dispatch('init')

		// Amplify Authentication dialog event handler
		onAuthUIStateChange((authState, authData) => {
			this.$store.dispatch('handleAuthChange', { authState, authData })
		})
	},

	// DEBUGGING
	watch: {
		responsiveSize(value) {
			console.info('RESPONSIVE CHANGE', value)
		}
	},

	computed: {
		showPageTitle() {
			return this.$route.name != 'Home'
		},

		pageTitle() {
			return this.$route.meta.title
		}
	},

	methods: {
		showLoad() {
			this.showLoading = true
		},
		closeLoad() {
			this.showLoading = false
		},
		showAuth() {
			this.showAuthentication = true
		},
		closeAuth() {
			this.showAuthentication = false
		},
		showMessage(message) {
			this.$refs.messages.showMessage(message)
		}
	}
}
</script>

<style lang="stylus">
.v-application {
	background: url('/img/wavesBg.jpg') !important;
	background-position: center !important;
	background-size: cover !important;
	background-attachment: fixed !important;
	background-repeat: no-repeat !important;
}

.leftOffset {
	margin-left: 320px;
}

html, body {
	height: 100%;
}

.opaqueBg {
	background-color: rgba(255, 255, 255, 0.9) !important;
}

.opaqueBg02 {
	background-color: rgba(255, 255, 255, 0.2) !important;
}

.opaquerBg {
	background-color: rgba(255, 255, 255, 0.6) !important;
}

.opaqueBlueBg {
	background-color: rgba(0, 56, 122, 0.8) !important;
}

.opaquerBlueBg {
	background-color: rgba(0, 56, 122, 0.5) !important;
}

.opaque {
	opacity: 0.9 !important;
}

.opaquer {
	opacity: 0.6 !important;
}

.linearGradient {
	background: linear-gradient(180deg, rgba(0, 56, 122, 0) 50%, rgba(255, 255, 255, 0.5) 100%);
}
</style>